import React from 'react';

function Error({ children, content, onClick }) {
  return (
    <div className="p-4 fixed w-full z-[99] top-0 left-0 flex items-center justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
      <div className="p-4 bg-white w-full rounded-md shadow-md" onClick={onClick} style={{ maxWidth: 414 }}>
        <div className="text-center">
          <p className="text-gray">{content}</p>
        </div>
        {children}
      </div>
    </div>
  );
}

export default Error;
